
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insuranceType]/login",
      function () {
        return require("private-next-pages/[insuranceType]/login/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[insuranceType]/login"])
      });
    }
  